<!-- xlsx.js (C) 2013-present  SheetJS -- http://sheetjs.com -->
<template>
  <v-btn color="primary" @click="exportData">
    <v-icon>mdi-upload</v-icon>
    <span>Exportar Datos</span>
  </v-btn>
</template>

<script>
import XLSX from "xlsx";

export default {
  data: () => ({
    data: [],
    practitionerData: []
  }),
  methods: {
    _export() {
      const ws = XLSX.utils.json_to_sheet(
        // this.data.map(item => ({
        //   ...item,
        //   ...item.organism,
        //   ...item.event,
        //   ...item.practitioner
        // }))
        this.data.map(e => ({
          ocurrencia_id: e.id,
          abundancia: e.individualCount,
          buceo_id: e.event.id,
          fecha_buceo: e.event.eventDateLegible,
          // fecha_buceo: e.event.eventDate,
          latitud_buceo: e.event.coordinates[0],
          longitud_buceo: e.event.coordinates[1],
          visibilidad: e.event.dynamicProperties.visibilityMeters,
          temperatura_min: e.event.measurementValue.temperatureMin,
          temperatura_max: e.event.measurementValue.temperatureMax,
          // lista_especies: e.event.organismList,
          id_buzo: e.event.recordedBy,
          id_especie: e.organism.id,
          nombre_comun_especie: e.organism.vernacularName,
          nombre_cientifico_especie: e.organism.scientificName,
          frecuencia_ocurrencia: e.organism.ocurrenceFrecuency,
          cantidad_buscado_biblioteca: e.organism.mostSearched,
          peso_asignado_abundanci: e.organism.weightAbundance,
          especie_validada: e.organism.validated,
          especie_visible_biblioteca: e.organism.sp_card
        }))
      );
      const ws_practitioner = XLSX.utils.json_to_sheet(
        this.practitionerData.map(p => ({
          id_buzo: p.id,
          nombre: p.name,
          email: p.email,
          telefono: p.phone,
          admin: p.hasAdminAccess,
          pais: p.country,
          region: p.region,
          comuna: p.province,
          centro_buceo: p.diveCenter,
          cantidad_buceos: p.dives,
          años_buceando: p.ageDives,
          horas_buceo: p.hrsDives
        }))
      );
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Ocurrencias");
      XLSX.utils.book_append_sheet(wb, ws_practitioner, "Buzos");
      XLSX.writeFile(wb, "Avistamientos.xlsx");
    },
    async exportData() {
      try {
        let { data } = await this.$http.post("occurrence/get-all");
        this.data = data;
        let { data: practitionerD } = await this.$http.get("practitioner");
        this.practitionerData = practitionerD;
        this._export();
      } catch (err) {}
    }
  }
};
</script>
